import { render, staticRenderFns } from "./Communique.vue?vue&type=template&id=565a9f6a&scoped=true&"
import script from "./Communique.vue?vue&type=script&lang=js&"
export * from "./Communique.vue?vue&type=script&lang=js&"
import style0 from "./Communique.vue?vue&type=style&index=0&id=565a9f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a9f6a",
  null
  
)

export default component.exports